import React from "react";
import { Link } from "@quintype/components";
import PropTypes from "prop-types";
import get from "lodash/get";
import { getSlug } from "../../../utils/utils";
import { FallbackImage } from "../FallbackImage";
import { useSelector } from "react-redux";
//import { LazyLoadImage } from "react-lazy-load-image-component";

import "./magazine-cover-image.m.css";

export const MagazineCoverImageCard = ({ collection, config = {}, isHomepage = false }) => {
  const coverImageData = get(collection, ["metadata", "cover-image"]) || {};
  const { magazineSlug = "", useLink = true } = config;
  const { "cover-image-url": coverUrl, "cover-image-s3-key": covers3Key } = coverImageData;

  const slug = magazineSlug && collection && getSlug(collection, config);

  const cdnImage = useSelector((state) => state.qt.config["cdn-image"]);
  const isImgFormatGif = covers3Key?.toLowerCase().endsWith(".gif");

  return (
    <div className="arr--magazine-cover-img" styleName="cover-image">
      {covers3Key || coverUrl ? (
        <figure styleName="image">
          {covers3Key ? (
            (() => {
              /*const coverImg = (
                <LazyLoadImage
                  src={`https://${cdnImage}/${covers3Key}?w=360&auto=format,compress&fit=max&q=85`}
                  width={360}
                  height={473}
                  alt="fortune magazine cover"
                  title="fortune magazine cover"
                  effect="blur" // nice blur-up effect
                  style={{ aspectRatio: "1/2", objectFit: "cover", width: "100%" }}
                  wrapperProps={{
                    style: {
                      height: "auto", // override height set on span
                      display: "block", // change from default inline-block if needed
                    },
                  }}
                />
              );*/
              const coverImg = (
                <img
                  // src={`https://${cdnImage}/${covers3Key}?w=480&auto=format,compress&fit=max&q=85`}
                  src={
                    isImgFormatGif
                      ? `https://${cdnImage}/${covers3Key}?w=480`
                      : `https://${cdnImage}/${covers3Key}?w=480&auto=format,compress&fit=max&q=85`
                  }
                  width={480}
                  height={654}
                  loading="lazy"
                  alt="fortune magazine cover"
                  title="fortune magazine cover"
                  style={{ aspectRatio: "1/2", objectFit: "cover", width: "100%" }}
                />
              );
              return useLink ? (
                <Link href={magazineSlug || slug} aria-label="magazine-cover-image" disableAjaxLinks={true}>
                  {coverImg}
                </Link>
              ) : (
                coverImg
              );
            })()
          ) : (
            <img src={`${coverUrl}?q=70`} loading="lazy" />
          )}
        </figure>
      ) : useLink ? (
        <Link href={magazineSlug || slug}>
          <div styleName="fallback-img">
            <FallbackImage slug={magazineSlug || slug} />
          </div>
        </Link>
      ) : (
        <div styleName="fallback-img">
          <FallbackImage slug={magazineSlug || slug} />
        </div>
      )}
    </div>
  );
};

MagazineCoverImageCard.propTypes = {
  collection: PropTypes.shape({
    "cover-image-url": PropTypes.string,
    "cover-image-s3-key": PropTypes.string,
    "cover-image-metadata": PropTypes.string,
    slug: PropTypes.string,
  }),
  config: PropTypes.shape({
    magazineSlug: PropTypes.string,
  }),
};
